
import React from 'react';
import { useTranslation } from 'react-i18next';

const LoadingIndicator: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="p-8 text-center">
      <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent"></div>
      <p className="mt-4">{t('loading.interviewRequest')}</p>
    </div>
  );
};

export default LoadingIndicator;
